import * as React from 'react';
import * as GiveFeedbackStore from '../feedback/store/giveFeedbackStore';
import GiveFeedbackDialog from '../feedback/GiveFeedbackDialog';
import { ApplicationState } from '../store';
import { connect } from 'react-redux';

type CustomDialogRendererProps = GiveFeedbackStore.GiveFeedbackState & typeof GiveFeedbackStore.actionCreators;


/**
 * Use this renderer component to show global dialogs if redux state changes. 
 * Connect dialogs to store actions.
 */
const CustomDialogRenderer: React.SFC<CustomDialogRendererProps> = (props) => {
    const { isDialogOpen } = props;

    return <div>
        <GiveFeedbackDialog open={isDialogOpen} onSubmit={(values) => props.giveFeedbackSubmit(values)} onCancel={props.giveFeedbackCancel} />
    </div>
}

const mapStateToProps = (state: ApplicationState) => {
    return state.giveFeedback;
}

export default connect<any, any, any>(mapStateToProps, GiveFeedbackStore.actionCreators)(CustomDialogRenderer);


// WEBPACK FOOTER //
// ./src/common/CustomDialogRenderer.tsx